.page {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
  max-width: 60rem;
  margin-inline: auto;
  box-sizing: border-box;
}

.headline {
  margin: 0;
  text-align: center;
  text-wrap: balance;
  font-size: 1.5rem;
  color: var(--rep-color-text-primary);
}

.pitch {
  padding: 0.75rem 1rem;
  color: var(--rep-color-text-secondary);

  background-color: var(--rep-color-surface-subtle);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-dialog);
}

.pitchTitle {
  margin: 0 0 0.5rem;
  font-size: 1.25rem;
  color: var(--rep-color-text-primary);
}

.seekingHelp {
  margin: 0;
  padding: 0.75rem 1rem;
  text-align: center;

  color: var(--rep-color-success-text);
  background-color: var(--rep-color-success-surface);
  border: 1px solid var(--rep-color-success-border);
  border-radius: var(--rep-radius-dialog);
}

.chart {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  margin: 0;
  padding: 0.75rem 1rem;

  background-color: var(--rep-color-surface);
  border: 1px solid var(--rep-color-border);
  border-radius: var(--rep-radius-dialog);
}

.chartTitle {
  text-align: center;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--rep-color-text-primary);
}

.chartImage {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
